import { useLayoutEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import { setActiveNavItem } from '../../../reducers/navItems';
import useLocation from '../../../hooks/useLocation';
import useNavItems from '../../../hooks/useNavItems';
import { selectMatchingNavItemPath } from '../../../selectors/nav-items.selectors';
const useActiveNavItemObserver = () => {
  const {
    byPath
  } = useNavItems();
  const {
    pathname
  } = useLocation();
  const dispatch = useAppDispatch();
  const activePath = useAppSelector(state => selectMatchingNavItemPath(state, {
    pathname
  }));
  const activeItem = activePath && byPath[activePath].id;
  useLayoutEffect(() => {
    if (activeItem) {
      dispatch(setActiveNavItem({
        id: activeItem
      }));
    }
  }, [activeItem, activePath, dispatch]);
};
export default useActiveNavItemObserver;